/* Quick-add de tamanho no card: clique no tamanho adiciona direto ao
   carrinho e abre a gaveta. Desktop: painel aparece no hover do card;
   mobile: botao "+" abre/fecha o painel. O fetch usa /cart/add.js, entao
   o Compre e Ganhe (brinde) intercepta normalmente. */
;(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.card-qa__toggle');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var card = toggle.closest('.product-card');
      var painel = card && card.querySelector('[data-card-qa]');
      var estava = painel && painel.classList.contains('card-qa--aberto');
      document.querySelectorAll('.card-qa--aberto').forEach(function (p) { p.classList.remove('card-qa--aberto'); });
      if (painel && !estava) painel.classList.add('card-qa--aberto');
      return;
    }
    /* clique fora fecha qualquer painel aberto */
    if (!e.target.closest || !e.target.closest('[data-card-qa]')) {
      document.querySelectorAll('.card-qa--aberto').forEach(function (p) { p.classList.remove('card-qa--aberto'); });
    }

    var btn = e.target.closest && e.target.closest('.card-qa__size');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.qaLoading) return;
    btn.dataset.qaLoading = '1';
    var texto = btn.textContent;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(btn.dataset.qaVid, 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add falhou');
      return r.json();
    }).then(function () {
      btn.textContent = '✓';
      setTimeout(function () {
        btn.textContent = texto;
        delete btn.dataset.qaLoading;
      }, 1200);
      try {
        if (typeof theme !== 'undefined' && theme.cart && theme.cart.drawer && document.getElementById('ajaxDrawer')) {
          theme.cart.drawer.reloadCart();
          theme.cart.drawer.openDrawer();
        }
      } catch (err) {}
    }).catch(function () {
      btn.textContent = texto;
      delete btn.dataset.qaLoading;
    });
  }, true);
})();
